import * as React from 'react';
import { Loading, ActivityIndicator } from 'zarm';
// import classnames from 'classnames';
import './index.scss';

// function delay(stamp) {
//   return new Promise((resolve) => {
//     setTimeout(resolve, stamp);
//   });
// }

export default class Player extends React.Component {
  static defaultProps = {
    sourceURL: '', // 视频播放地址
    onCancel: e => e, // 取消关闭
  }
  
  constructor(props) {
    super(props);

    this.offsetRef = React.createRef();
    // 播放器实例
    this.videoRef = React.createRef();
    // 播放器id
    this.uid = `id-${Math.random().toString(32).slice(2)}`;
  }

  state = {
    // visible: true, // 显示播放器
    // controls: false, // 是否显示控制条
    // touchActive: false, // 点击播放时
    // paused: true, // 视频是否停止播放
  }

  componentDidMount() {
    Loading.show({ content: <ActivityIndicator size="lg" /> });

    const player = window.videojs(this.uid, { 
      width: document.documentElement.clientWidth,
      height: document.documentElement.clientHeight,
      controls: true,
      controlBar: {
        children: [
          'playToggle',
          'volumePanel',
          'currentTimeDisplay',
          'timeDivider',
          'durationDisplay',
          'progressControl',
          'liveDisplay',
          'remainingTimeDisplay',
          // 'customControlSpacer',
          // 'playbackRateMenuButton',
          // 'chaptersButton',
          // 'descriptionsButton',
          // 'subtitlesButton',
          // 'captionsButton',
          // 'subsCapsButton',
          // 'audioTrackButton',
          // 'fullscreenToggle'
        ]
      },
      autoplay: false,
      loop: false,
      muted: false,
      preload: 'metadata',
    }, () => {
      player.on('play', function() {//开始播放
        Loading.hide();
        // console.log("开始播放")
      });

      player.on('error', function() {//请求数据时遇到错误
        Loading.hide();
      });

      player.on('ended', function() {//播放结束
        console.log("播放结束")
      });
    });
  }
  
  render() {
    const { sourceURL, sourceImage, onCancel } = this.props;
    // const { controls, touchActive, paused } = this.state;

    return (
      <React.Fragment>
        <div className="cancel" onClick={onCancel}>
          <i className="iconfont icon-tuichu1" />
        </div>
        <div
          className="video-player-container"
        >
          <video
            id={this.uid}
            autoPlay
            poster={sourceImage}
            playsInline="playsInline"
            className="video-js vjs-default-skin vjs-big-play-centered"
          >
            {/* <source src="http://vjs.zencdn.net/v/oceans.mp4" type="video/mp4" /> */}
            <source src={sourceURL} type="video/mp4" />
          </video>
        </div>
      </React.Fragment>
    );
  }
}

